var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_4826)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_332_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 35,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5H45V45.5H10V10.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_332_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2985 29.9331C42.2985 38.1061 35.6731 44.7314 27.5001 44.7314C19.327 44.7314 12.7017 38.1061 12.7017 29.9331C12.7017 25.3441 14.79 21.2432 18.0679 18.5287C20.2239 16.7445 22.894 15.5591 25.8226 15.2289C26.3728 15.1668 26.9327 15.1346 27.5001 15.1346C35.6731 15.1346 42.2985 21.76 42.2985 29.9331Z",
    fill: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.1351C27.2184 15.1351 26.9389 15.1437 26.6611 15.1593C34.4436 15.5942 40.6205 22.042 40.6205 29.9333C40.6205 37.8245 34.4436 44.2723 26.6611 44.7073C26.9389 44.7228 27.2184 44.7314 27.5 44.7314C35.6728 44.7314 42.2981 38.1061 42.2981 29.9333C42.2981 21.7604 35.6728 15.1351 27.5 15.1351Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8226 15.2292V26.8135C21.5303 26.8135 18.0508 23.334 18.0508 19.0417C18.0508 18.8694 18.0562 18.6985 18.0679 18.529C20.2239 16.7448 22.894 15.5594 25.8226 15.2292Z",
    fill: "#99E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2721 19.0414C35.2721 23.3338 31.7925 26.8135 27.5001 26.8135C23.2077 26.8135 19.728 23.3338 19.728 19.0414C19.728 14.7491 23.2077 11.2694 27.5001 11.2694C31.7925 11.2694 35.2721 14.7491 35.2721 19.0414Z",
    fill: "#4FC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.2694C27.2166 11.2694 26.9368 11.285 26.6611 11.3145C30.559 11.7329 33.5944 15.0325 33.5944 19.0414C33.5944 23.0503 30.559 26.3499 26.6611 26.7683C26.9368 26.7978 27.2166 26.8135 27.5 26.8135C31.7924 26.8135 35.272 23.3337 35.272 19.0414C35.272 14.749 31.7924 11.2694 27.5 11.2694Z",
    fill: "#47A920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7414 19.2184L25.2654 17.7424C24.9817 17.4588 24.522 17.4588 24.2384 17.7424L23.2747 18.7061C22.9911 18.9897 22.9911 19.4495 23.2747 19.7331L25.7437 22.2021C26.2555 22.7139 27.0851 22.7139 27.5968 22.2021L32.425 17.374C32.7085 17.0904 32.7085 16.6306 32.425 16.347L31.5324 15.4544C31.2488 15.1708 30.7889 15.1708 30.5054 15.4544L26.7414 19.2184Z",
    fill: "#D1F19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4246 16.347L31.532 15.4544C31.2484 15.1708 30.7887 15.1708 30.505 15.4544L30.1797 15.7797L30.747 16.347C31.0306 16.6306 31.0306 17.0904 30.747 17.374L26.5763 21.5681C26.2774 21.867 25.8701 21.99 25.481 21.9397L25.7435 22.2021C26.2551 22.7139 27.0848 22.7139 27.5965 22.2021L32.4246 17.374C32.7082 17.0904 32.7082 16.6306 32.4246 16.347Z",
    fill: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7668 34.5439H12.2332C11.283 34.5439 10.5127 33.7737 10.5127 32.8235V27.0419C10.5127 26.0917 11.283 25.3214 12.2332 25.3214H42.7668C43.717 25.3214 44.4873 26.0917 44.4873 27.0419V32.8235C44.4873 33.7737 43.717 34.5439 42.7668 34.5439Z",
    fill: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.767 25.3214H41.0894C42.0396 25.3214 42.8098 26.0917 42.8098 27.0419V32.8235C42.8098 33.7737 42.0396 34.5439 41.0894 34.5439H42.767C43.7172 34.5439 44.4874 33.7737 44.4874 32.8235V27.0419C44.4874 26.0917 43.7172 25.3214 42.767 25.3214Z",
    fill: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9537 38.9021L28.2145 39.4304C28.2882 39.5798 28.4307 39.6833 28.5955 39.7072L29.1785 39.792C29.5935 39.8523 29.7593 40.3623 29.459 40.655L29.0371 41.0663C28.9178 41.1825 28.8634 41.35 28.8915 41.5142L28.9911 42.0949C29.062 42.5082 28.6282 42.8234 28.257 42.6283L27.7355 42.3541C27.5881 42.2766 27.412 42.2766 27.2645 42.3541L26.7431 42.6283C26.3718 42.8234 25.938 42.5082 26.0089 42.0949L26.1085 41.5142C26.1366 41.35 26.0822 41.1825 25.963 41.0663L25.541 40.655C25.2407 40.3623 25.4064 39.8523 25.8215 39.792L26.4046 39.7072C26.5694 39.6833 26.7118 39.5798 26.7855 39.4304L27.0463 38.9021C27.2318 38.526 27.7681 38.526 27.9537 38.9021Z",
    fill: "#FDDF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1786 39.792L28.5955 39.7073C28.4307 39.6833 28.2883 39.5798 28.2145 39.4305L27.9538 38.9021C27.7682 38.526 27.2319 38.526 27.0463 38.9021L26.8335 39.3332C26.9362 39.5255 27.068 39.6957 27.2674 39.7073L27.8505 39.792C28.2656 39.8523 28.4313 40.3623 28.131 40.655C27.9339 40.8697 27.4727 41.1677 27.5636 41.5141L27.6632 42.0948C27.6768 42.1746 27.6713 42.2506 27.6515 42.3201C27.6801 42.3291 27.7084 42.3398 27.7355 42.3541L28.257 42.6283C28.6282 42.8234 29.062 42.5081 28.9911 42.0948L28.8915 41.5141C28.8634 41.35 28.9178 41.1825 29.0371 41.0663L29.459 40.655C29.7593 40.3623 29.5936 39.8523 29.1786 39.792Z",
    fill: "#FAC600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4346 34.5445C15.3726 40.4597 20.9377 44.7314 27.5002 44.7314C34.0627 44.7314 39.6278 40.4597 41.5658 34.5445",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0532 17.2043C38.1014 19.0173 40.4427 21.8931 41.5658 25.3213",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4346 25.3213C14.2732 22.7616 15.7909 20.5097 17.775 18.7785",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7668 34.5439H12.2332C11.283 34.5439 10.5127 33.7737 10.5127 32.8235V27.0419C10.5127 26.0917 11.283 25.3214 12.2332 25.3214H42.7668C43.717 25.3214 44.4873 26.0917 44.4873 27.0419V32.8235C44.4873 33.7737 43.717 34.5439 42.7668 34.5439Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0029 40.1211C34.497 39.0172 36.5098 37.0243 37.6396 34.5442",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3604 34.5446C18.4853 37.0142 20.4859 39.0007 22.9653 40.1074",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6397 25.3213C36.9828 23.8788 36.0271 22.602 34.8521 21.5684",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.148 21.5684C18.9729 22.602 18.0173 23.8789 17.3604 25.3213",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9537 38.9021L28.2145 39.4304C28.2882 39.5798 28.4307 39.6833 28.5955 39.7072L29.1785 39.792C29.5935 39.8523 29.7593 40.3623 29.459 40.655L29.0371 41.0663C28.9178 41.1825 28.8634 41.35 28.8915 41.5142L28.9911 42.0949C29.062 42.5082 28.6282 42.8234 28.257 42.6283L27.7355 42.3541C27.5881 42.2766 27.412 42.2766 27.2645 42.3541L26.7431 42.6283C26.3718 42.8234 25.938 42.5082 26.0089 42.0949L26.1085 41.5142C26.1366 41.35 26.0822 41.1825 25.963 41.0663L25.541 40.655C25.2407 40.3623 25.4064 39.8523 25.8215 39.792L26.4046 39.7072C26.5694 39.6833 26.7118 39.5798 26.7855 39.4304L27.0463 38.9021C27.2318 38.526 27.7681 38.526 27.9537 38.9021Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0785 25.3213C34.0145 23.9076 35.2716 21.6217 35.2716 19.0411C35.2716 14.7488 31.7921 11.2693 27.4998 11.2693C23.2075 11.2693 19.728 14.7488 19.728 19.0411C19.728 21.6217 20.9852 23.9076 22.9211 25.3213",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1059 19.6931L32.425 17.374C32.7086 17.0905 32.7086 16.6306 32.425 16.3471L31.5324 15.4544C31.2488 15.1709 30.789 15.1709 30.5054 15.4544L26.7414 19.2184L25.2654 17.7424C24.9818 17.4588 24.522 17.4588 24.2384 17.7424L23.2747 18.7062C22.9911 18.9897 22.9911 19.4496 23.2747 19.7331L25.7437 22.2022C26.2555 22.7139 27.0851 22.7139 27.5968 22.2022L28.4022 21.3969",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2915 31.6113L13.6138 28.1394C13.6408 28.0734 13.7343 28.0733 13.7615 28.1393L15.0717 31.6113",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5567 28.1952H37.0864V31.6846H38.5567",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4483 29.9404H37.0864",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3232 28.1457V31.5039",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6711 29.8509C42.6711 30.7924 42.1485 31.5376 41.3194 31.5521C41.0434 31.5568 40.3301 31.5596 40.3301 31.5596C40.3301 31.5596 40.3257 30.3218 40.3257 29.8471C40.3257 29.4573 40.3232 28.1423 40.3232 28.1423H41.2911C42.2005 28.1423 42.6711 28.9093 42.6711 29.8509Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7681 28.0898L33.9721 31.5584C33.9972 31.6295 34.0979 31.6288 34.1222 31.5575L35.272 28.0963",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6973 29.9462L26.1765 31.627",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2725 28.1054V31.627",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1762 29.0212C26.1762 29.5267 25.733 29.9365 25.2091 29.9365C24.9494 29.9365 24.2799 29.9404 24.2799 29.9404C24.2799 29.9404 24.2758 29.276 24.2758 29.0212C24.2758 28.812 24.2734 28.106 24.2734 28.106H25.2091C25.733 28.106 26.1762 28.5158 26.1762 29.0212Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7852 28.1054V31.627",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7789 29.0995C18.7789 29.6483 18.3146 30.0933 17.7657 30.0933C17.4935 30.0933 16.792 30.0977 16.792 30.0977C16.792 30.0977 16.7876 29.3762 16.7876 29.0995C16.7876 28.8723 16.7852 28.1057 16.7852 28.1057H17.7657C18.3146 28.1057 18.7789 28.5507 18.7789 29.0995Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5288 28.1054V31.627",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5226 29.0995C22.5226 29.6483 22.0582 30.0933 21.5094 30.0933C21.2371 30.0933 20.5356 30.0977 20.5356 30.0977C20.5356 30.0977 20.5313 29.3762 20.5313 29.0995C20.5313 28.8723 20.5288 28.1057 20.5288 28.1057H21.5094C22.0582 28.1057 22.5226 28.5507 22.5226 29.0995Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4145 29.8506C31.4145 30.823 30.6262 31.6113 29.6538 31.6113C28.6814 31.6113 27.8931 30.823 27.8931 29.8506C27.8931 28.8781 28.6814 28.0898 29.6538 28.0898C30.6262 28.0898 31.4145 28.8781 31.4145 29.8506Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_4826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans8);
export default __webpack_public_path__ + "static/media/trans8.55043dd47eedb349e167b96f1922154f.svg";
export { ForwardRef as ReactComponent };